import React, { useState } from "react";
import api from "../../../api/api";
import ParentPanel from "../panel/ParentPanel";
import "../styles/ExamPage.css"; 
import {
  FaClipboardList,
  FaBookOpen,
  FaTasks,
  FaMedal,
  FaPencilRuler,
  FaProjectDiagram,
  FaFileAlt,
  FaFlask,
  FaTrophy,
  FaDownload,
  FaBrain,
  FaQuestionCircle,
  FaLightbulb
} from "react-icons/fa";

const ExamPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeExam, setActiveExam] = useState(null);
  const [results, setResults] = useState([]);
  const [loadingResults, setLoadingResults] = useState(false);
  // Regular Exams
  const regularExams = [
    { name: "Unit Test 1", icon: <FaClipboardList />, color: "sr-orange1", status: "notStarted" },
    { name: "Unit Test 2", icon: <FaClipboardList />, color: "sr-red1", status: "inProgress" },
    { name: "Half-Yearly Exam", icon: <FaBookOpen />, color: "sr-green1", status: "finished" },
    { name: "Annual Exam", icon: <FaMedal />, color: "sr-darkred1", status: "notStarted" },
    { name: "Mid-Term Test", icon: <FaFileAlt />, color: "sr-blue1", status: "notStarted" },
    { name: "Final Term Exam", icon: <FaTrophy />, color: "sr-deeporange1", status: "notStarted" },
  ];

  // Brain Activity Exams
  const brainExams = [
    { name: "Quiz Exam", icon: <FaQuestionCircle />, color: "sr-purple1", status: "inProgress" },
    { name: "Brain Test", icon: <FaBrain />, color: "sr-pink1", status: "notStarted" },
    { name: "Olympiad Exam", icon: <FaLightbulb />, color: "sr-green1", status: "notStarted" },
  ];

  const dummyResults = [
    { subject: "Math", marks: 88 },
    { subject: "Science", marks: 92 },
    { subject: "English", marks: 85 },
    { subject: "History", marks: 90 },
  ];

  // Hover text based on status
  const getHoverText = (status) => {
    switch(status) {
      case "notStarted": return "Click to begin this exam";
      case "inProgress": return "Resume your ongoing exam";
      case "finished": return "You have completed this exam";
      default: return "";
    }
  };

  // Render cards for a section
  const renderExamCards = (examsArray) =>
    examsArray.map((exam, index) => (
      <div
        key={index}
        className={`sr-card1 ${exam.color} ${exam.status}`}
        onClick={() => handleExamClick(exam)}
      >
        <div className="sr-left1">
          <div className="sr-label1">{exam.name}</div>
          <div className="sr-count1">
            {exam.status === "notStarted" && "Start Exam"}
            {exam.status === "inProgress" && "Resume Exam"}
            {exam.status === "finished" && "Exam Finished"}
          </div>
        </div>
        <div className="sr-icon-chip1">{exam.icon}</div>
        <span className="sr-card-tooltip">{getHoverText(exam.status)}</span>
      </div>
    ));

    const handleExamClick = async (exam) => {
  try {
    setLoadingResults(true);
    setActiveExam(exam);

    const res = await api.get(`/api/exams/results?exam=${encodeURIComponent(exam.name)}`);

    setResults(res.data || []);

  } catch (err) {
    console.error("Failed to fetch exam results:", err);
    setResults([]);
  } finally {
    setLoadingResults(false);
  }
};

  return (
    <>
      <ParentPanel onToggle={setIsSidebarCollapsed} />

      <div className={`sr-main-content1 ${isSidebarCollapsed ? "collapsed" : ""}`}>
        {/* Regular Exams Section */}
        <h3 className="sr-title1">
          <FaBookOpen style={{ marginRight: "8px" }} /> Regular Exams
        </h3>
        <div className="sr-card-grid1">
          {renderExamCards(regularExams)}
        </div>

        {/* Brain Activity Exams Section */}
        <h3 className="sr-title1" style={{ marginTop: "40px" }}>
          <FaBrain style={{ marginRight: "8px" }} /> Brain Activity Exams
        </h3>
        <div className="sr-card-grid1">
          {renderExamCards(brainExams)}
        </div>
      </div>

      {/* Result Card Modal */}
      {activeExam && (
        <div className="sr-modal-backdrop1" onClick={() => setActiveExam(null)}>
          <div className="sr-result-card1" onClick={(e) => e.stopPropagation()}>
            <h3 className="sr-result-title1">{activeExam.name} - Results</h3>
            <table className="sr-result-table1">
              <thead>
                <tr>
                  <th>Subject</th>
                  <th>Marks</th>
                </tr>
              </thead>
              <tbody>
                {dummyResults.map((res, idx) => (
                  <tr key={idx}>
                    <td>{res.subject}</td>
                    <td>{res.marks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button className="download-btn1">
              <FaDownload style={{ marginRight: "6px" }} /> Download PDF
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ExamPage;
